import { connect } from 'react-redux'
import BillingCreditCardRow from './BillingCreditCardRow'
import showBillingAddCreditCardFormModal from '../BillingAddCreditCardFormModal'

const stateToProps = () => ({})

const dispatchToProps = {
  showBillingAddCreditCardFormModal,
}

export default connect(stateToProps, dispatchToProps)(BillingCreditCardRow)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingCreditCardRow/BillingCreditCardRow.container.js